/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  TrackingV2Response
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all tracking ids based on a given master data shop id
 */
export const getTrackingByShopId = (
    masterDataShopId: string,
 options?: SecondParameter<typeof customInstance<TrackingV2Response>>,) => {
      return customInstance<TrackingV2Response>(
      {url: `/api/v2/tracking/shop/${masterDataShopId}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Returns all tracking ids based on a given google GA4 id
 */
export const getTrackingByGa4Id = (
    ga4Id: string,
 options?: SecondParameter<typeof customInstance<TrackingV2Response>>,) => {
      return customInstance<TrackingV2Response>(
      {url: `/api/v2/tracking/ga4/${ga4Id}`, method: 'GET'
    },
      options);
    }
  export type GetTrackingByShopIdResult = NonNullable<Awaited<ReturnType<typeof getTrackingByShopId>>>
export type GetTrackingByGa4IdResult = NonNullable<Awaited<ReturnType<typeof getTrackingByGa4Id>>>
